import { useEffect } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import Hero from "./components/Hero";
import TrustStats from "./components/TrustStats";
import About from "./components/About";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Gallery from "./components/Gallery";
import WhyUs from "./components/WhyUs";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";
import Contact from "./components/Contact";
import SiteFooter from "@/components/feature/SiteFooter";

export default function Home() {
  useEffect(() => {
    document.title = "Urban Infra | Premium Plots on Sarjapur Road";

    const setMeta = (name: string, content: string, prop = false) => {
      const selector = prop
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;
      let el = document.querySelector(selector) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        if (prop) el.setAttribute("property", name);
        else el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Urban Infra offers premium villa plots and eco-friendly communities on Sarjapur Road, Bangalore. Explore our projects, download brochures, and book a site visit."
    );
    setMeta(
      "keywords",
      "Urban Infra, villa plots on Sarjapur Road, premium plots Bangalore, eco-friendly communities Bangalore, gated community plots Bangalore, residential layouts Bangalore"
    );
    setMeta("og:title", "Urban Infra | Premium Plots on Sarjapur Road", true);
    setMeta(
      "og:description",
      "Urban Infra offers premium villa plots and eco-friendly communities on Sarjapur Road, Bangalore. Explore our projects, download brochures, and book a site visit.",
      true
    );
    setMeta("og:url", `${import.meta.env.VITE_SITE_URL ?? "https://www.urbaninfraprojects.in"}/`, true);
    setMeta("og:site_name", "Urban Infra", true);

    // Schema.org JSON-LD
    const schemaId = "schema-home";
    let script = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = schemaId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://www.urbaninfraprojects.in";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "RealEstateAgent",
      name: "Urban Infra",
      description:
        "Urban Infra offers premium villa plots and eco-friendly communities on Sarjapur Road, Bangalore. Explore our projects, download brochures, and book a site visit.",
      url: siteUrl,
      telephone: "+919945124133",
      email: "sales@urbaninfraproject.in",
      logo: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/4503346b-1bc6-47f8-8ad2-efa626492725_IMG_1999.png",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "#2, CNR Complex, First Floor, Muthanallur Cross, Sarjapur Main Road",
        addressLocality: "Bangalore",
        addressRegion: "Karnataka",
        postalCode: "562125",
        addressCountry: "IN",
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ],
          opens: "11:00",
          closes: "19:00",
        },
      ],
      areaServed: {
        "@type": "City",
        name: "Bengaluru",
      },
      sameAs: [
        "https://wa.me/919945124133",
      ],
    });

    window.scrollTo(0, 0);

    return () => {
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <SiteHeader />
      <main>
        <Hero />
        <TrustStats />
        <About />
        <Services />
        <Projects />
        <Gallery />
        <WhyUs />
        <Testimonials />
        <CTASection />
        <Contact />
      </main>
      <SiteFooter />
    </div>
  );
}
